/* XPERT Nursing: quick-fact flip card */
if (!customElements.get('xpr-flip-facts')) {
  customElements.define('xpr-flip-facts', class extends HTMLElement {
    connectedCallback() {
      try { this.facts = JSON.parse(this.querySelector('[data-facts]').textContent); } catch (e) { this.facts = []; }
      if (!this.facts.length) return;
      this.i = 0;
      this.flipped = false;
      this.card = this.querySelector('[data-flip]');
      this.querySelectorAll('[data-toggle]').forEach((b) => b.addEventListener('click', () => this.setFlip(!this.flipped)));
      this.querySelector('[data-prev]').addEventListener('click', () => this.go(this.i - 1));
      this.querySelector('[data-next]').addEventListener('click', () => this.go(this.i + 1));
      this.querySelectorAll('[data-go]').forEach((b) => b.addEventListener('click', () => this.go(Number(b.dataset.go))));
    }
    setFlip(on) {
      this.flipped = on;
      this.card.classList.toggle('is-flipped', on);
      this.querySelector('[data-label]').textContent = on ? 'Show question' : 'Flip it';
      this.querySelector('.xpr-flip__card').setAttribute('aria-label', on ? 'Show the question again' : 'Flip to see the answer');
      this.querySelector('.xpr-flip__front').setAttribute('aria-hidden', on ? 'true' : 'false');
      this.querySelector('.xpr-flip__back').setAttribute('aria-hidden', on ? 'false' : 'true');
    }
    go(k) {
      const n = this.facts.length;
      this.i = (k + n) % n;
      const f = this.facts[this.i];
      const wasFlipped = this.flipped;
      this.setFlip(false);
      const swap = () => {
        this.card.style.setProperty('--fact', f.color);
        this.querySelectorAll('[data-f]').forEach((el) => { el.textContent = f[el.dataset.f] || ''; });
      };
      if (wasFlipped) setTimeout(swap, 300); else swap();
      this.querySelector('[data-num]').textContent = this.i + 1;
      this.querySelectorAll('[data-go]').forEach((b, j) => {
        if (j === this.i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
    }
  });
}
